import { useState } from "react";
import { useDispatch } from "react-redux";
import { loginAdmin } from "../store/action";
import { useNavigate } from "react-router-dom";

function Login() {
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const [loginInput, setLoginInput] = useState({
        email: '',
        password: ''
    })

    const handleChange = (e) => {
        const { value, name } = e.target
        const input = {
            ...loginInput,
            [name]: value
        }
        setLoginInput(input)
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        dispatch(loginAdmin(loginInput))
            .then(resp => resp.json())
            .then((data) => {
                console.log(data);

                if(data.access_token){
                    localStorage.setItem('access_token', data.access_token)
                }
                
                navigate('/')
            })
            .catch(console.log)

        setLoginInput({
            email: '',
            password: '',
        })

    }

    return (
        <>
            <div className="card text-center w-50 mx-auto my-5">
                <div className="card-header">
                    Aci Hardware Store
                </div>
                <div className="card-body">
                    <h5 className="card-title">Admin Access</h5>
                    <form>
                        <div className="row pt-5 px-5">
                            <div className="col-3">
                                Email
                            </div>
                            <div className="col">
                                <input onChange={handleChange} value={loginInput.email} type="email" className="form-control" name="email" />
                            </div>
                        </div>
                        <div className="row px-5 pt-3 pb-5">
                            <div className="col-3">
                                Password
                            </div>
                            <div className="col">
                                <input type="password" onChange={handleChange} value={loginInput.password} className="form-control" name="password" />
                            </div>
                        </div>
                        <button onClick={handleSubmit} type="submit" className="btn btn-danger w-50">Submit</button>
                    </form>
                </div>
                <div className="card-footer text-muted">
                    © Aci Hardware Indonesia, All rights reserved.
                </div>
            </div>
        </>
    )
}

export default Login